<div class="lessons-list-container">
  <mat-expansion-panel
    #panelRef
    expanded="true"
    *ngFor="let section of sections; let sectionNumber = index"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="section-header noselect">
          <!-- <div class="section-number">Section: {{ sectionNumber + 1 }}</div> -->
          <div class="course-title">
            <h3>
              {{ section.title }}
            </h3>
          </div>
        </div>
      </mat-panel-title>
      <mat-panel-description>
        <div class="section-data">
          <span *ngIf="sectionsLessons[section.id]?.sectionLessons.length > 0"
            >{{ calculateLessonsCompleted(section) }}/{{
              calculateSectionLength(section)
            }}</span
          >
        </div>
        <mat-icon>{{ panelRef.expanded ? "remove" : "add" }}</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <lessons-list
      [course]="course"
      [sectionSeqNo]="section.seqNo"
      [lessons]="sectionsLessons[section.id]"
      [lessonsWatched]="lessonsWatched"
      [playlistMode]="playlistMode"
      [highlightedLesson]="activeLesson"
    >
    </lessons-list>
  </mat-expansion-panel>
</div>
